module.exports = __webpack_public_path__ + "img/fab4c248-18f0-45f2-877d-4391e6e94aea.41ef97df.svg";